function Directive() {
  return {
    link(scope, element, attrs) {
      element.css({
        background: `${(attrs.bgColor ? attrs.bgColor : '')} url(${attrs.bgImg}) center center`,
        'background-size': 'cover'
      });
      attrs.$observe('bgImg', function(img) {
        element.css({
          background: `${(attrs.bgColor ? attrs.bgColor : '')} url(${img}) center center`,
          'background-size': 'cover'
        });
      });
    }
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/bgImg/index.js